<div class="header">
  <div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
    <div class="contentInner">
      <div class="pageTitle">
        <h1 class="headline">Dash Enterprise</h1>
      </div>
    </div>
    <app-enterprise-tab-navigator></app-enterprise-tab-navigator>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <h1 class="title">User Administration</h1>
    <p class="intro">Dash Enterprise's user administration features allow you to control who has access to the web management
      dashboard, and the actions they can perform.</p>

    <h1 class="sectionHeader">Overview</h1>
    <app-illustration src="/assets/images/dash-enterprise-user-admin-overview.png" webpSrc="/assets/images/dash-enterprise-user-admin-overview.webp" width="1586" height="1018" class="illustration"></app-illustration>
    <p>
      The user overview shows all the user accounts that exist in your organization.  For each user, you can see their
      current status and level of access, and also perform the following actions:
    </p>
    <ul>
      <li>Editing the user to change their name or roles</li>
      <li>Enabling or disabling the user's sign-in access</li>
      <li>Resetting a user's two-factor authentication (for users who have two-factor authentication enabled on their account)</li>
      <li>Deleting the user account</li>
      <li>Resending the user's invitation email (only available for users that have not yet completed the signup process)</li>
    </ul>

    <h1 class="sectionHeader">Adding users</h1>
    <app-illustration src="/assets/images/dash-enterprise-new-user.png" webpSrc="/assets/images/dash-enterprise-new-user.webp" width="600" height="733" class="illustration"></app-illustration>
    <p>
      To add a new user, click the <i>New user</i> button in the toolbar.  You'll need to enter the user's first name and
      email address, and decide whether to require two-factor authentication (2FA) for their account.  You can also You
      can also select the roles you want to assign to the user.  The available roles are:
    </p>
    <ul>
      <li><b>User manager - </b>can access the user administration function in the dashboard, and has
      the ability to add, edit, and remove users, as well as set their roles.</li>
      <li><b>Configuration manager - </b>can create, edit and delete device groups and their device configurations.</li>
      <li><b>Device manager - </b>can activate and deactivate Dash display devices and assign them to existing device groups</li>
    </ul>
    <p>
      Roles are additive, meaning that assigning multiple roles to a user will grant them all the associated permissions.
      If a user is not assigned any role, they will have read-only access to the dashboard.
    </p>
    <p>
      Clicking the <i>Invite</i> button will send the user a welcome email containing login instructions and a temporary
      password.  To activate their account, the user must sign in within 4 days and set a permanent password.
    </p>
    <p>
      When the invite email is sent, the user's account status will show as <i>Invited</i>. Once they sign in and choose
      a permanent password, their status will change to <i>Active</i>.  If the user does not sign in within 4 days, you
      can resend the welcome email by clicking the <i>Resend</i> button in the users table.
    </p>
    <h1 class="sectionHeader">Editing users</h1>
    <p>
      To edit a user, select the user in the table and click the <i>Edit</i> button in the toolbar.  You can change the user's display name as well as their roles.
    </p>
    <p class="tip icon">Note that it can take up to 1 hour for role changes to take effect.  The user can refresh their roles immediately by signing out of the dashboard and signing in again.</p>

    <h1 class="sectionHeader">Resetting a user's two-factor authentication</h1>
    <p>
      If a user has lost their authenticator device or is otherwise unable to enter their code when signing in, you can
      disable two-factor authentication (2FA) on their account to allow them to access the dashboard. Simply click
      <i>Reset</i> in the <i>2FA status</i> column of the user table, and they will be able to sign in.
    </p>

    <p class="tip icon">If the user's account is set to require 2FA, they'll be prompted to set up a new authenticator
      when they sign in.  If 2FA is optional for their account, they can set it up themselves from the account details menu.
    </p>

    <h1 class="sectionHeader">Disabling access and deleting accounts</h1>
    <p>
      There are two ways to disable a user's access to the dashboard:
    </p>
    <ul>
      <li><b>Disable account access - </b>To temporarily disable a user's access, click the <i>Disable</i> button in the <i>Account Access</i> column of the users table. This action keeps the account in the system but removes the user's ability to sign in. It is useful for temporarily restricting access.</li>
      <li><b>Delete the account - </b>To permanently delete a user's account, click the trash can icon in the users table. This action will remove the account from the system permanently.</li>
    </ul>
    <p class="tip icon">Note that a user cannot disable or delete their own account.  A user account can only be deleted by another user with the <i>User manager</i> role.</p>

  </div>
</div>
